import React, { useEffect, useState } from "react";
import cn from "classnames";
import style from "../common.module.scss";
import { Expeditor, Order } from "../../../../services";
import CustomButton from "../../../custom/custom-button/CustomButton";
import { toast } from "react-toastify";
import OrderBookingCard from "../../../../pages/orders/booking/OrderBookingCard";
import CloseIconNew from "../../../shared/icons/CloseIconNew";
import CustomInput from "../../../custom/custom-input/CustomInput";
import AccessDeniedModal from "../../../shared/SubscriptionModal/AccessDeniedModal";
import {t} from "i18next";

const AssignExecutor = ({ user, orderId, onUpdateData, fetchOrderData}) => {
  const [isBooked, setBookedState] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [getOrder, setOrder] = useState(null);
  const [drivers, setDrivers] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isSuggestPrice, setSuggest] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [suggestPrice, setSuggestPrice] = useState("");
  const [errorText, setErrorText] = useState("");
  const [isDisplayModal, changeDisplayModal] = useState(false)

  const handleSuggestPrice = () => {
    const roundedPrice = Math.round(Number(suggestPrice));

    if (!roundedPrice) {
      setErrorText("Введите цену");
      return;
    }
    if (roundedPrice <= 0) {
      setErrorText("Введите корректную положительную цену");
      return;
    }

    setErrorText("");
    setIsOpen(true);
  };

  const fetchOrderDataById = async () => {
    setLoading(true);
    try {
      const { data } = await Order.getOrderForExpeditor({ orderId });
      setBookedState(data.isBooked);
      setOrder(data.order);
      if (data.vehicle && data.driver) {
        getBookData({
          driver: data.driver,
          transport: data.vehicle,
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const getBookData = ({ driver, transport }) => {
    setDrivers([
      {
        ...driver,
        vehicle: transport,
      },
    ]);
  };

  const sendOrderBooking = async () => {
    try {
      const driver = drivers[0] || {};
      const body = {
        driverId: driver.id,
        vehicleId: driver.vehicle?.id,
      };
      await Order.sendOrderBook(getOrder.id, body);
      setIsOpenModal(false);
      toast.success("Водитель успешно назначен");
      fetchOrderData();
      onUpdateData();
    } catch (e) {
      toast.error("Произошла ошибка, попробуйте позже");
      console.log("Ошибка при назначение водителя", e);
    }
  };

  const sendSuggestPrice = async () => {
    try {
      const driver = drivers[0] || {};
      const body = {
        orderId: getOrder.id,
        driverId: driver.id,
        vehicleId: driver.vehicle?.id,
        price: suggestPrice
      };
      await Expeditor.sendAuctionBid(body);
      setIsOpen(false);
      toast.success("Цена успешно отправлена");
      fetchOrderData();
      onUpdateData();
    } catch (e) {
      toast.error("Произошла ошибка, попробуйте позже");
      console.log("Ошибка при назначение водителя", e);
    }
  };

  const onDeleteDriver = (driver) => {
    if (isBooked) {
      // onCancelBooking()
    } else {
      setDrivers(drivers.filter((d) => d.id !== driver.id));
    }
  };

  useEffect(() => {
    fetchOrderDataById();
  }, [orderId]);

  return (
    <div className={cn(style.cargo_wrapper)}>
      {isDisplayModal && <AccessDeniedModal onClose={() => changeDisplayModal(false)} />}

      <div style={{ display: "flex", gap: "16px", width: "100%" }}>
        <CustomButton
          text={t ("orderInfo.bookOrder")}
          style={{ flex: "1" }}
          onClick={() => {
            if (user?.state === "Pending") {
              return toast.info("Вы не можете забронировать заказ, необходимо загрузить документы");
            }
            if (user?.state === "Moderation") {
              return toast.info("Вы не можете забронировать заказ, модератор еще не подтвердил ваши документы");
            }
            if (user?.state !== "Confirmed") {
              return toast.info("Вы не можете забронировать заказ, необходимо пройти верификацию");
            }
            if (user && user.permissions?.includes("restricted_view")) {
              return changeDisplayModal(true);
            }
            setIsOpenModal(true);
            setSuggestPrice("");
            setSuggest(false);
          }}
          isLoading={isLoading}
        />
        <CustomButton
          text={t ("orderInfo.suggestYourPriceButton")}
          style={{ flex: "1" }}
          onClick={() => {
            if (user?.state === "Pending") {
              return toast.info("Вы не можете предложить свою цену, необходимо загрузить документы");
            }
            if (user?.state === "Moderation") {
              return toast.info("Вы не можете предложить свою цену, модератор еще не подтвердил ваши документы");
            }
            if (user?.state !== "Confirmed") {
              return toast.info("Вы не можете предложить свою цену, необходимо пройти верификацию");
            }
            if (user && user.permissions?.includes("restricted_view")) {
              return changeDisplayModal(true);
            }
            setSuggest(true)
          }}
          isLoading={isLoading}
        />
      </div>
      {isSuggestPrice && (
        <div style={{ display: "flex", gap: "16px", width: "100%" }}>
          <CustomInput
            value={suggestPrice}
            isBgGray
            inputType="number"
            prefixEnd={<span>〒</span>}
            labelText={t ("orderInfo.yourPriceLabel")}
            placeholder={t ("orderInfo.yourPricePlaceholder")}
            onChangeValue={(value) => setSuggestPrice(value)}
            errorText={errorText}
            style={{ flex: "2" }}
          />
          <CustomButton
            text={t ("orderInfo.suggestPriceButton")}
            style={{ flex: "1" }}
            onClick={handleSuggestPrice}
          />
        </div>
      )}

      {isOpen && (
        <div className={cn("modal-overlay", style.modal)}>
          <div className={style.modal_content}>
            <CloseIconNew
              onClick={() => setIsOpen(false)}
              style={{ cursor: "pointer" }}
            />
            <CustomButton
              text={t ("orderInfo.assignExecutor")}
              // style={{ flex: "1" }}
              onClick={() => sendSuggestPrice()}
              isLoading={isLoading}
              isDisabled={!drivers.length || isBooked}
            />
            {drivers.map((driver, index) => (
              <OrderBookingCard
                key={"driver-id-" + driver.id}
                index={index}
                driver={driver}
                companyId={user?.companyId}
                orderId={orderId}
                onDelete={onDeleteDriver}
                isBooked={isBooked}
                getDataSubmit={getBookData}
              />
            ))}
            <OrderBookingCard
              key={"driver-create"}
              isHide={drivers.length}
              index={drivers.length}
              companyId={user?.companyId}
              orderId={orderId}
              isBooked={isBooked}
              getDataSubmit={getBookData}
            />
          </div>
        </div>
      )}

      {isOpenModal && (
        <div className={cn("modal-overlay", style.modal)}>
          <div className={style.modal_content}>
            {/* <CloseIconNew
              onClick={() => setIsOpenModal(false)}
              style={{ cursor: "pointer" }}
            /> */}
            {drivers && drivers.length > 0 && (
              <CustomButton
                text={t('driversCreate.button.confirm')}
                // style={{ flex: "1" }}
                onClick={() => sendOrderBooking()}
                isLoading={isLoading}
                isDisabled={!drivers.length || isBooked}
              />
            )}
            {drivers.map((driver, index) => (
              <OrderBookingCard
                key={"driver-id-" + driver.id}
                index={index}
                driver={driver}
                companyId={user?.companyId}
                orderId={orderId}
                onDelete={onDeleteDriver}
                isBooked={isBooked}
                getDataSubmit={getBookData}
                isOpenModal={setIsOpenModal}
              />
            ))}
            <OrderBookingCard
              key={"driver-create"}
              isHide={drivers.length}
              index={drivers.length}
              companyId={user?.companyId}
              orderId={orderId}
              isBooked={isBooked}
              getDataSubmit={getBookData}
              isOpenModal={setIsOpenModal}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AssignExecutor;
